import { isMobile, CountryCode } from '@/utils';
import Tracker from './tracker';
import { getQuery } from '@/utils/url';

type TLabels = Record<string, string>;

interface ITrackerProps {
  /** labels.search */
  labels?: TLabels;
  action: string;
  /** ga label */
  label?: string;
}

// 将object转换key1=value1&key2=value2的字符串
function convertObjectToString(obj: TLabels) {
  const entries = Object.entries(obj);
  // 只有一个key的时候，不需要&分割，直接上报value
  if (entries.length === 1) {
    return entries[0][1];
  }

  return (
    entries
      .reduce((prev, [key, value]) => {
        return (prev += `&${key}=${value}`);
      }, '')
      // 去除第一个&
      .substring(1)
  );
}

class SearchTracker extends Tracker {
  /** 搜索框行为上报 */
  searchBarTracing = ({ labels = {}, action }: ITrackerProps) => {
    try {
      const baseLabels: TLabels = {
        code: CountryCode,
        pathname: window.location.pathname,
      };
      const mixedLabel = Object.assign(baseLabels, labels);
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_search_bar`,
        action,
        label: convertObjectToString(mixedLabel),
        value: labels.search ?? getQuery('search'),
      });
    } catch (e) {
      console.error(e);
    }
  };

  /** 结果页的行为上报 */

  searchResultsPageTracing = ({ labels = {}, action, label }: ITrackerProps) => {
    try {
      const baseLabels = {
        code: CountryCode,
      };
      const mixedLabel = Object.assign(baseLabels, labels);
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_search_result_page`,
        action,
        label: label ?? convertObjectToString(mixedLabel),
        value: labels.search ?? getQuery('search'),
      });
    } catch (e) {
      console.error(e);
    }
  };
}

export default new SearchTracker();
